import { defineComponent as _defineComponent } from 'vue'
import AdminNavigation from "../../AdminNavigationContainer.vue";
import Loading from "@/components/home/Loading.vue";
import Alert from "@/components/scan/parts/Alert.vue";
import { ref, onMounted, reactive, onUpdated, onBeforeUnmount } from "vue";
import StationForSystemDataService from "@/services/StationForSystemDataService";
import { useI18n } from "vue3-i18n";
import ResponseData from "@/types/ResponseData";
import { store } from "@/store/store";


export default /*#__PURE__*/_defineComponent({
  setup(__props, { expose }) {
  expose();

const isLoading = ref(true);
const i18n = useI18n();
const title = ref("SCAN-PC Batch Control Maintenance");
const stationCodeInfo = reactive([]);
const alertMessage = ref("null");
const alertState = ref("neutral");
const getData = ref(false);
const modalStationSystemCode = reactive([]);

onMounted(function () {
  window.addEventListener('resize', handleResize);
  isLoading.value = true;
  getStationCodeInfo();
});

onBeforeUnmount(() => {
  window.removeEventListener('resize', handleResize);
});

function handleResize() {
  store.dispatch("setIsPageLoad", false);
  try {
    var newsTableHeight = 0;
    var newsDataHeight = document.getElementById("tblTbody")?.clientHeight;
    if (newsDataHeight != 0) {
      newsTableHeight = document.getElementById("tblSystembodydiv")?.clientHeight;
      if (newsDataHeight > newsTableHeight) {
        document.getElementById("tblSystembodydiv").style.width = "100%";
      } else {
        document.getElementById("tblSystembodydiv").style.width = "calc(100% - 16px)";
      }
    }
  } catch {
    isLoading.value = false;
  }
}

const getStationCodeInfo = () => {
  /** Get Station Code for System List */
  stationCodeInfo.splice(0);

  /** 二回目実行にアラートメッセージが表示修正 */
  alertMessage.value = "null";
  alertState.value = "neutral";

  if(store.getters.pcCompanyListData != null && store.getters.isPageLoad == false ){
    for(let pcComObj of store.getters.pcCompanyListData){
      stationCodeInfo.push(pcComObj);
    }
    getData.value = true;
    isLoading.value = false;
  }else{
    /** get Station Code for System Data  */
    StationForSystemDataService.getStationCodeForSystem()
      .then((response: ResponseData) => {
        if (response.data.length !== 0) {
          store.dispatch("setPcCompanyListData",response.data);
          for (let info of response.data) {
            stationCodeInfo.push(info);
          }
        }
        getData.value = true;
        isLoading.value = false;
      })
      .catch((e: Error) => {
        console.log(e);
        alertMessage.value = i18n.t("err048");
        alertState.value = "error";
        isLoading.value = false;
      });
  }
};

const addStationCodeForSystem = () => {
  store.dispatch("setId", 0);
  store.dispatch("setSelectedStation", "");
  store.dispatch("setDataId", "");
  store.dispatch("setFtpUserId", "");
  store.dispatch("setShowPage", "BatchControl");
};
/** edit station code for system  pageに移動*/
const editStationCodeForSystem = (
  id: any,
  stationCode: any,
  dataId: any,
  ftpUserID: any
) => {
  store.dispatch("setId", id);
  store.dispatch("setSelectedStation", stationCode);
  store.dispatch("setDataId", dataId);
  store.dispatch("setFtpUserId", ftpUserID);
  store.dispatch("setShowPage", "BatchControl");
};

const deleteStationCodeForSystem = (id: any) => {
  /** delete modal表示*/
  modalStationSystemCode.splice(0);
  modalStationSystemCode.push(id);
};

const deleteRow = (id: any) => {
  /** 二回目実行にアラートメッセージが表示修正*/
  alertMessage.value = "null";
  alertState.value = "neutral";
  isLoading.value = true;

  const data = { systemid: id };
  /** delete station code for system*/
  StationForSystemDataService.deleteStationCodeForSystem(data)
    .then((_) => {
      var stInfoList = [];
      for(let pcComObj of store.getters.pcCompanyListData){
        if(pcComObj.id != id){
          stInfoList.push(pcComObj);
        }
      }
      store.dispatch("setPcCompanyListData", stInfoList);
      stationCodeInfo.splice(0);
      for(let pcComObj of store.getters.pcCompanyListData){
        stationCodeInfo.push(pcComObj);
      }
      alertMessage.value = i18n.t("suc024");
      alertState.value = "success";
      isLoading.value = false;
    })
    .catch((e: Error) => {
      console.log(e);
      alertMessage.value = i18n.t("err046");
      alertState.value = "error";
      isLoading.value = false;
    });
};

onUpdated(function () {
  handleResize();
});

const __returned__ = { isLoading, i18n, title, stationCodeInfo, alertMessage, alertState, getData, modalStationSystemCode, handleResize, getStationCodeInfo, addStationCodeForSystem, editStationCodeForSystem, deleteStationCodeForSystem, deleteRow, AdminNavigation, Loading, Alert }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})